module.exports = __webpack_public_path__ + "media/application/images/ui/logo-no-strap-78d826aa19a9337f938d2a4c78244620.png";